module.exports = __webpack_public_path__ + "img/house.6390260.svg";